import React from "react";
import AdminEditNews from "../../Components/Admin/AdminEditNews";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditNewsPage = ()=>{
    return (
      <AdminEditNews />
    )
}

export default AdminEditNewsPage;